import React, { useState, VFC } from 'react';
import styled from 'styled-components';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';

const decideSize = (size?: string | number) => {
  if (typeof size === 'string') return size;
  if (!!size) return `${size}px`;
  return 'auto';
};

const ImageWrapper = styled.div<{
  width?: string | number;
  height?: string | number;
  loaded: boolean;
}>`
  display: flex;
  justify-content: ${({ loaded }) => (loaded ? 'normal' : 'center')};
  align-items: ${({ loaded }) => (loaded ? 'flex-end' : 'center')};
  width: ${({ width }) => decideSize(width)};
  height: ${({ height }) => decideSize(height)};
  margin: 4px;
  overflow: hidden;
`;
const Img = styled.img<{
  width?: string | number;
  height?: string | number;
  loaded: boolean;
}>`
  display: ${({ loaded }) => (loaded ? 'block' : 'none')};
  width: ${({ width }) => decideSize(width)};
  height: ${({ height }) => decideSize(height)};
`;

const useStyles = makeStyles<
  Theme,
  { width?: string | number; height?: string | number }
>({
  skeltonRoot: ({ width, height }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'black',
    width,
    height,
  }),
});

interface Props {
  src: string;
  alt: string;
  width?: string | number;
  height?: string | number;
}
const Image: VFC<Props> = ({ src, alt, width, height }: Props) => {
  const sizeProps = { width, height };
  // atomsにあたるようなコンポーネントでは、本来はstate管理すべきではないが、
  // img要素が読み込まれたかどうかのハンドリングのために例外的に利用している
  const [loaded, setLoaded] = useState(false);
  const { skeltonRoot } = useStyles(sizeProps);
  const handleLoad = () => {
    setLoaded(true);
  };

  return (
    <ImageWrapper {...sizeProps} loaded={loaded}>
      <Img
        src={src}
        alt={alt}
        loaded={loaded}
        onLoad={handleLoad}
        {...sizeProps}
      />
      {!loaded && <Skeleton variant="rect" classes={{ root: skeltonRoot }} />}
    </ImageWrapper>
  );
};

export default Image;
